import { gql } from "@apollo/client";

export const remoteAssetFragment = gql`
    fragment RemoteAssetFields on RemoteAsset {
        id
        name
        description
        type
        previewImageUrl: iconUrl
        assetSize
        lensUsages
        createdAt
        createdBy
        updatedAt
        updatedBy
        forkingAllowed
    }
`;
